export default "__VITE_ASSET__Dh99UCT0__"